import React, { PropsWithChildren } from 'react'

import FlightSearchWidgetStateProvider from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateProvider'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import useFlightSearchContext from 'hooks/FlightSearchWidget/useFlightSearchContext'
import useGlobalSearchContext from 'hooks/GlobalSearch/useGlobalSearchContext'
import AITripSearchContextProvider from 'tripPlanner/contexts/Search/AITripSearchContextProvider'
import useAITripSearchContext from 'tripPlanner/hooks/useAITripSearchContext'

const TripSearchProvider = ({ children }: PropsWithChildren<{}>) => {
  const { globalSearchDispatch, globalSearchState } = useGlobalSearchContext()
  const { flightSearchDispatch, flightSearchState } = useFlightSearchContext()
  const { aiTripSearchDispatch, aiTripSearchState } = useAITripSearchContext()

  return (
    <GlobalSearchContextProvider
      state={globalSearchState}
      dispatch={globalSearchDispatch}
    >
      <FlightSearchWidgetStateProvider
        state={flightSearchState}
        dispatch={flightSearchDispatch}
      >
        <AITripSearchContextProvider
          state={aiTripSearchState}
          dispatch={aiTripSearchDispatch}
        >
          {children}
        </AITripSearchContextProvider>
      </FlightSearchWidgetStateProvider>
    </GlobalSearchContextProvider>
  )
}

export default TripSearchProvider
